<template>
  <div class="card" id="threeDModel">
    <nav class="fixed-bar navbar navbar-expand-lg navbar-light" color="white">
      <h3 class="navbar-brand">3D Model</h3>
      <add-model2-d
        @save="saveSetDesign"
        @open="openDialog"
        @close="closeDialog"
        v-bind:dialog="dialog"
        v-bind:info="editedItem"
        v-bind:edited-i-d="editedID"
        v-bind:showSaveButton="showSaveButton">
      </add-model2-d>
    </nav>
    <hr/>
    <div class="container fluid grid-list-lg">
      <asset-table
        v-bind:updated="updated"
        v-bind:asset_type="asset_type"
        @edit="editItem"
        v-bind:headers="headers">
      </asset-table>
    </div>
  </div>
</template>

<script>
import AddModel2D from './add-new/addModel2D'
import AssetTable from './assetTable'
import {db, assetMediaStorageRef, assetModelStorageRef} from '../../firebaseDB'

export default {
  name: 'props',
  components: { AssetTable, AddModel2D },
  data: () => ({
    asset_type: 'prop',
    headers: [
      {th: 'Name', name: 'name'},
      {th: 'Date Uploaded', name: 'date_uploaded'},
      // {th: 'Date Modified', name: 'date_modified'},
      {th: 'Uploaded By', name: 'creator'},
      // {th: 'Description', name: 'description'},
      // {th: 'Service', name: 'service'},
      {th: 'Media',
        name: 'media',
        render (row, cell, index) {
          if (row.hasOwnProperty('image')) {
            return `<a href="${row.image.imageURL}" target="_blank">
                  <img src="${row.image.imageURL}" style="width: 50px; height: 50px">
                </a>`
          } else {
            return ''
          }
        }
      },
      // {th: 'Rig', name: 'rig'},
      {th: 'Scale', name: 'scale'},
      {th: 'Polygon Count', name: 'polygon_count'},
      // {th: 'Asset Dimensions (meters x,y,z)', name: 'dimension_revised'}
    ],
    fileType: {
      image: 'image',
      fdx: 'fdx',
      asset_bundle: 'asset_bundle'
    },
    osType: {
      iOS: 'iOS',
      Android: 'Android',
      WebGL: 'WebGL'
    },
    dialog: false,
    updated: false,
    showSaveButton: true,
    editedItem: {
      id: null,
      name: '',
      description: '',
      service: '',
      image: null,
      fileURL: '',
      allowed_sounds: [],
      allowed_animations: [],
      rig: '',
      polygon_count: 1,
      dimension: {
        X: 0,
        Y: 0,
        Z: 0
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scale: 0,
      materials: '',
      interactive_surfaces: '',
      polygonLimitation: ''
    },
    defaultItem: {
      id: null,
      name: '',
      service: '',
      description: '',
      image: null,
      allowed_sounds: [],
      allowed_animations: [],
      rig: '',
      surface: [1],
      polygon_count: 1,
      dimension: {
        X: 0,
        Y: 0,
        Z: 0
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        WebGL: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      scale: 0,
      materials: '',
      interactive_surfaces: '',
      polygonLimitation: ''
    },
    editedID: -1,
    editedIndex: -1,
    tableData: []
  }),
  methods: {
    saveSetDesign (updatedData) {
      const currentDate = new Date()
      const datetime = currentDate.getDate() + '/' +
        (currentDate.getMonth() + 1) + '/' +
        currentDate.getFullYear() + ' @ ' +
        currentDate.getHours() + ':' +
        currentDate.getMinutes() + ':' +
        currentDate.getSeconds()
      setTimeout(() => {
        let updates = {}
        let requireDefaultUpdate = true
        if (!updatedData.id) {
          updatedData.id = db.ref(`asset_data/${this.asset_type}/`).push().key
          updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/creator`] = this.$store.state.user.email
          updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_uploaded`] = datetime
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/name`] = updatedData.name || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/service`] = updatedData.service || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/description`] = updatedData.description || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_modified`] = datetime

        updates[`asset_data/${this.asset_type}/${updatedData.id}/sounds`] = updatedData.allowed_sounds || []
        updates[`asset_data/${this.asset_type}/${updatedData.id}/rig`] = updatedData.rig || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/scale`] = updatedData.scale || 0
        updates[`asset_data/${this.asset_type}/${updatedData.id}/animations`] = updatedData.allowed_animations || []

        updates[`asset_data/${this.asset_type}/${updatedData.id}/polygon_count`] = updatedData.polygon_count || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/dimension`] = {
          X: updatedData.dimension.X || '',
          Y: updatedData.dimension.Y || '',
          Z: updatedData.dimension.Z || ''
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/positionOfOrigin`] = {
          X: updatedData.positionOfOrigin.X || '',
          Y: updatedData.positionOfOrigin.Y || '',
          Z: updatedData.positionOfOrigin.Z || ''
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/rotationOfOrigin`] = {
          X: updatedData.rotationOfOrigin.X || '',
          Y: updatedData.rotationOfOrigin.Y || '',
          Z: updatedData.rotationOfOrigin.Z || ''
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/scale`] = updatedData.scale || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/materials`] = updatedData.materials || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/interactive_surfaces`] = updatedData.interactive_surfaces || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/polygonLimitation`] = updatedData.polygonLimitation || ''
        // updates[`asset_data/${this.asset_type}/${updatedData.id}/surface`] = updatedData.surface || ''
        if (this.shouldUpload(this.fileType.image, updatedData)) {
          this.uploadImage(updatedData, updates)
          requireDefaultUpdate = false
        }
        if (this.shouldUpload(this.fileType.fbx, updatedData)) {
          this.uploadFBX(updatedData, updates)
          requireDefaultUpdate = false
        }
        if (this.shouldUpload(this.fileType.asset_bundle, updatedData)) {
          this.uploadAssetBundle(updatedData, updates, this.osType.iOS)
          this.uploadAssetBundle(updatedData, updates, this.osType.Android)
          this.uploadAssetBundle(updatedData, updates, this.osType.WebGL)
          requireDefaultUpdate = false
        }
        if (requireDefaultUpdate) {
          db.ref('assets').update(updates).then(snapshot => {
            this.closeDialog()
            this.updated = true
          })
        }
      }, 2000)
      this.updated = false
    },
    // shouldUpload (fileType, updatedData) {
    //   if (fileType === this.fileType.image) {
    //     return updatedData.image && updatedData.image.imageFile
    //   } else if (fileType === this.fileType.fbx) {
    //     return updatedData.files && updatedData.files.length !== 0
    //   } else {
    //     return false
    //   }
    // },

    shouldUpload (fileType, updatedData) {
      if (fileType === this.fileType.image) {
        return updatedData.image && updatedData.image.imageFile
      } else if (fileType === this.fileType.fbx) {
        return updatedData.fbx && updatedData.fbx.file
      } else if (fileType === this.fileType.asset_bundle) {
        return (updatedData.asset_bundle.iOS && updatedData.asset_bundle.iOS.file) ||
          (updatedData.asset_bundle.Android && updatedData.asset_bundle.Android.file) ||
          (updatedData.asset_bundle.WebGL && updatedData.asset_bundle.WebGL.file)
      } else {
        return false
      }
    },
    uploadFBX (updatedData, updates) {
      assetModelStorageRef.child(`${updatedData.id}/original.fbx`)
        .put(updatedData.fbx.file)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then((url) => {
          updatedData.fbx.fileURL = url
          console.log('Transferring file url')
        })
        .then(snapshot => {
          updates[`asset_data/${this.asset_type}/${updatedData.id}/fbx`] = updatedData.fbx || {
            fileURL: '',
            file: ''
          }
          console.log('Your fbx file is saved in storage')
          db.ref('assets').update(updates)
            .then(snapshot => {
              this.closeDialog()
              this.updated = true
              console.log('Your fbx fileURL is saved in assets')
            })
        })
    },
    uploadAssetBundle (updatedData, updates, osType) {
      if (updatedData.asset_bundle[osType] && updatedData.asset_bundle[osType].file) {
        assetModelStorageRef.child(`${updatedData.id}/${osType}`)
          .put(updatedData.asset_bundle[osType].file)
          .then(snapshot => snapshot.ref.getDownloadURL())
          .catch(function (error) {
            console.log(`Error - ${error.message}`)
          })
          .then((url) => {
            updatedData.asset_bundle[osType].fileURL = url
            console.log('Transferring asset bundle url')
          })
          .then(snapshot => {
            let key = `asset_data/${this.asset_type}/${updatedData.id}/asset_bundle/${osType}`
            updates[key] = updatedData.asset_bundle[osType] || {
              fileURL: '',
              file: ''
            }
            console.log(`Your ${osType} asset bundle is saved in storage`)
            db.ref('assets').update(updates)
              .then(snapshot => {
                this.closeDialog()
                this.updated = true
                console.log(`Your ${osType} asset bundle fileURL is saved in assets`)
              })
          })
      }
    },

    // uploadFBX (updatedData, updates) {
    //   assetPropStorageRef.child(`${updatedData.id}.fbx`)
    //     .put(updatedData.files[0])
    //     .then(snapshot => snapshot.ref.getDownloadURL())
    //     .catch(function (error) {
    //       console.log('Error - ' + error.message)
    //     })
    //     .then((url) => {
    //       updatedData.fileURL = url
    //       console.log('Transferring file url')
    //     })
    //     .then(snapshot => {
    //       updates[`asset_data/${this.asset_type}/${updatedData.id}/fileURL`] = updatedData.fileURL
    //       console.log('Your fbx files are saved in storage')
    //       db.ref('assets').update(updates)
    //         .then(snapshot => {
    //           this.closeDialog()
    //           this.updated = true
    //           console.log('Your fileURL are saved in assets')
    //         })
    //     })
    // },
    uploadImage (updatedData, updates) {
      assetMediaStorageRef.child(`${updatedData.id}.jpg`)
        .put(updatedData.image.imageFile)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
        .then((url) => {
          updatedData.image.imageURL = url
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
        .then(snapshot => {
          updates[`asset_data/${this.asset_type}/${updatedData.id}/image`] = updatedData.image || {imageURL: '', imageFile: ''}
          console.log('Your image file is saved in storage')
          db.ref('assets').update(updates)
            .then(snapshot => {
              this.closeDialog()
              this.updated = true
              console.log('Your fileURL are saved in assets')
            })
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
    },
    openDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.editedID = -1
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
      this.dialog = false
    },
    editItem (item) {
      this.editedIndex = item.index
      this.editedID = item.id
      this.editedItem = Object.assign(this.getEditedItem(item.item), item.item)
      this.editedItem.fileURL = item.item.fileURL || ''
      if (!this.editedItem.hasOwnProperty('positionOfOrigin')) {
        this.editedItem.positionOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      if (!this.editedItem.hasOwnProperty('rotationOfOrigin')) {
        this.editedItem.rotationOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      this.dialog = true
      this.showSaveButton = item.showSaveButton
    },
    getEditedItem (item) {
      let additional1 = []
      let additional2 = []
      db.ref(`assets/asset_data/prop/${item.id}/sounds`)
        .once('value')
        .then((snapshot) => {
          if (snapshot.val()) {
            Object.keys(snapshot.val()).forEach(function (k) {
              additional1.push(snapshot.val()[k])
            })
          }
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
      db.ref(`assets/asset_data/prop/${item.id}/actions`)
        .once('value')
        .then((snapshot) => {
          if (snapshot.val()) {
            Object.keys(snapshot.val()).forEach(function (k) {
              additional2.push(snapshot.val()[k])
            })
          }
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
      return {
        allowed_sounds: additional1,
        allowed_animations: additional2
      }
    }
  }
}
</script>

<style scoped>
#threeDModel{
  scroll-margin: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/props.vue